import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { GenericModalComponent } from '@vsolv/ui-kit/modal';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'vs-send-email-modal',
  templateUrl: './send-email-modal.component.html',
  standalone: false,
})
export class SendEmailModalComponent {
  @ViewChild('modal') modal?: GenericModalComponent;

  @Output() submitEvent = new EventEmitter<string>();
  @Output() closed = new EventEmitter<boolean>();

  open() {
    this.modal?.open();
  }

  close() {
    this.modal?.close();
  }

  toggle() {
    this.modal?.toggle();
  }
}
